// Header fixo (home e internas), carrosséis com setas e "Ver todos os bairros".

function iniciarHeaderFixo() {
    const header = document.getElementById('siteHeader');
    if (!header) {
        return;
    }
    const hero = document.querySelector('.home-hero');
    const naHome = hero && header.classList.contains('site-header--transparente');
    // Internas: a barra de busca aparece depois que a pessoa começa a rolar a página.
    const nasInternas = header.classList.contains('site-header--busca-rolagem');
    if (!naHome && !nasInternas) {
        return;
    }

    let fixo = false;
    function atualizar() {
        const limite = naHome ? hero.offsetHeight - header.offsetHeight : 320;
        const deveFixar = window.scrollY > limite;
        if (deveFixar !== fixo) {
            fixo = deveFixar;
            header.classList.toggle('is-fixo', fixo);
        }
    }

    window.addEventListener('scroll', atualizar, { passive: true });
    window.addEventListener('resize', atualizar);
    atualizar();
}

function iniciarCarrosseis() {
    document.querySelectorAll('.carrossel-setas').forEach((setas) => {
        const trilho = document.getElementById(setas.dataset.alvo);
        if (!trilho) {
            return;
        }
        const anterior = setas.querySelector('.js-carrossel-anterior');
        const proximo = setas.querySelector('.js-carrossel-proximo');

        function passo() {
            const item = trilho.firstElementChild;
            const gap = parseFloat(getComputedStyle(trilho).columnGap) || 0;
            return item ? item.getBoundingClientRect().width + gap : trilho.clientWidth;
        }

        function atualizar() {
            const max = trilho.scrollWidth - trilho.clientWidth - 2;
            anterior.disabled = trilho.scrollLeft <= 2;
            proximo.disabled = trilho.scrollLeft >= max;
            setas.hidden = trilho.scrollWidth <= trilho.clientWidth + 2;
        }

        anterior.addEventListener('click', () => trilho.scrollBy({ left: -passo(), behavior: 'smooth' }));
        proximo.addEventListener('click', () => trilho.scrollBy({ left: passo(), behavior: 'smooth' }));
        trilho.addEventListener('scroll', atualizar, { passive: true });
        window.addEventListener('resize', atualizar);
        atualizar();
    });
}

function iniciarBairrosHome() {
    const lista = document.getElementById('homeBairros');
    if (!lista) {
        return;
    }
    document.querySelectorAll('.js-bairros-todos').forEach((botao) => {
        botao.addEventListener('click', () => {
            const aberto = lista.classList.toggle('is-todos');
            document.querySelectorAll('.js-bairros-todos').forEach((b) => {
                b.setAttribute('aria-expanded', aberto ? 'true' : 'false');
                b.innerHTML = aberto ? 'Ver menos bairros' : 'Ver todos os bairros&nbsp;&nbsp;→';
            });
        });
    });
}

// Fale Conosco: #encomende e #anuncie abrem direto a aba correspondente.
function iniciarAbaContato() {
    const abas = { '#encomende': 'encomende-seu-imovel-tab', '#anuncie': 'anuncie-seu-imovel-tab' };
    function abrir() {
        const aba = document.getElementById(abas[window.location.hash] || '');
        if (aba) {
            aba.click();
            aba.closest('.contato-v2').scrollIntoView({ block: 'start' });
        }
    }
    abrir();
    // Já na página de contato, o link do header só troca o "#": troca a aba também.
    window.addEventListener('hashchange', abrir);
}

// Botão flutuante do WhatsApp: para 16px acima da linha do rodapé para não cobrir os links de baixo.
function iniciarWhatsappFlutuante() {
    const botao = document.querySelector('.whatsapp-flutuante');
    const linha = document.querySelector('.site-footer__base');
    if (!botao || !linha) {
        return;
    }

    let agendado = false;
    function atualizar() {
        agendado = false;
        const limite = linha.getBoundingClientRect().top - 16;
        const base = window.innerHeight - parseFloat(getComputedStyle(botao).bottom);
        const subir = Math.min(0, limite - base);
        botao.style.transform = subir ? `translateY(${subir}px)` : '';
    }
    function agendar() {
        if (!agendado) {
            agendado = true;
            window.requestAnimationFrame(atualizar);
        }
    }

    window.addEventListener('scroll', agendar, { passive: true });
    window.addEventListener('resize', agendar);
    atualizar();
}

// Assinatura "Feito com Qualitare" no rodapé: no desktop o nome se revela no hover (CSS);
// em telas de toque, que não têm hover, se revela sozinho quando a assinatura aparece na tela.
function iniciarAssinatura() {
    const assinatura = document.querySelector('.js-assinatura-qualitare');
    if (!assinatura || window.matchMedia('(hover: hover)').matches || !('IntersectionObserver' in window)) {
        return;
    }
    const observador = new IntersectionObserver((entradas) => {
        if (entradas.some((entrada) => entrada.isIntersecting)) {
            window.setTimeout(() => assinatura.classList.add('is-revelada'), 250);
            observador.disconnect();
        }
    }, { threshold: 1 });
    observador.observe(assinatura);
}

export default {
    init() {
        iniciarAssinatura();
        iniciarWhatsappFlutuante();
        iniciarHeaderFixo();
        iniciarCarrosseis();
        iniciarBairrosHome();
        iniciarAbaContato();
    },
};
